import React from 'react';

/** Shimmer placeholder bar — use inside tables/cards to preserve layout while loading. */
export default function SkeletonBar({ className = 'w-full h-4' }) {
  return (
    <div
      className={`relative overflow-hidden rounded-md bg-dark-surface/90 ${className}`}
      aria-hidden
    >
      <div className="absolute inset-0 animate-pulse bg-dark-border/30" />
      <div className="absolute inset-0 -translate-x-full animate-shimmer bg-gradient-to-r from-transparent via-white/[0.07] to-transparent" />
    </div>
  );
}
